<template>
  <div>
    <Pane title="离职申请" :showRemarks="false">
      <template>重新发起离职申请流程</template>
    </Pane>
    <div >
      <LeaveAdd :extra="extra" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import LeaveAdd from "@/views/human-resources/leave/add.vue";

export default {
  components: {
    LeaveAdd
  },
  filters: {
    dateFormat(val) {
      if (!val) return '—';
      return moment(val).format('YYYY-MM-DD');
    },
  },
  computed: {
    ...mapState("approval", ["detail"]),
    extra() {
      return (this.detail && this.detail.extra) ? this.detail.extra : {};
    },
    fileList() {
      const list = this.extra.attachmentList;
      if (Array.isArray(list)) {
        return list.filter(item => item && item.id);
      }
      return [];
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
    };
  },
};
</script>